import React, { useCallback, useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import GreenArrowUp from "../../../components/Images/GreenArrowUp";
import RedArrowDown from "../../../components/Images/RedArrowDown";
import Tooltip from "../../../CustomTooltip";
import { Box } from "../../../designSystem";
import DropDownSelect from '../../../components/GenericDropDownSelect'
import { get } from '../../../lib/api'
import{
    ColumnFlexContainer,
    ComparisonText,
    DataCount,
    DataHeading,
    DataPercentage,
    PerformanceDiv,
    RowFlexContainerWithGap,
    PerformanceHeading,
    PerformanceMainDiv,
    ViewMore,
    RefreshTime
} from './style'
import InfoIcon from "../../../components/Images/InfoIcon";
import { handleEventLog } from "../../../lib/utils";
import { handleNewEventLog } from "../../../lib/utils/events";

const toolTipContent = {
    "Published Days" : "No. of days with chapters published in the selected period",
    "Word Counts" : "Total Words published in the selected period",
    "Active Listeners" : "No. of Valid listener who listened in the selected period / Total Valid  listeners who heard the series",
    "Chapter Listeners" : "No. of Valid listener who listened to the chapters published in the selected period / Total Valid  listeners who heard the series",
    "Revenue Share":"Net Revenue Share earned by the author for the series in given selected period",
    "Revenue":"Gross revenue earned by the series in given selected period ",
    "Revenue Fast Pass":"Gross revenue earned by the series in given selected period in fast pass",
    "Schedule Episodes":"Episodes scheduled by the series in given period"
} 

const SeriesPerformanceCard = ({ bookId, newVersion = false, user, bookDetails }) => {
    const [filter,setFilter] = useState('last_7_days')
    const [seriesPerformanceData, updateSeriesPerformanceData] = useState(null)
    const [lastRefreshTime, setLastRefreshTime] = useState(null)
    const viewMoreInfoButton = useRef(null)
    const tooltipInfoButton = useRef([])

    const handleRefreshTime = (time) => {
      const newTime = dayjs(time).format('DD/MM/YYYY hh:mm A') 
      return newTime
    }
    useEffect(async() => {
      console.log("test series performance")
    
      const fetchData = async (apiEndpoint) => {
        try {
          const res = await get(apiEndpoint)
          const data = []
    
          for (const property in res) {
            if (property === "last_refresh_time") {
              setLastRefreshTime(res[property])
              continue
            }
            data.push({
              title: property.split("_").map((str) => str.charAt(0).toUpperCase() + str.slice(1)).join(" "),
              ...res[property],
            })
          }
    
          return data
        } catch (error) {
          return null
        }
      }

      const novelPerformanceData = await fetchData(`/user_api/novel_performance_ugc?book_id=${bookId}`)
      const novelRevenueData = await fetchData(`/user_api/novel_revenue_performance_ugc?book_id=${bookId}&is_novel=2`)
     
      const combinedData = [
        ...novelPerformanceData,
        ...novelRevenueData

      ]

      updateSeriesPerformanceData(combinedData)
    
    }, [bookId])
    
    const sendAnalyticsDataHandler = () => {
        handleEventLog('home_seriesperformance', 'button_click', {
          module_name: 'clickhereformoreinformation',
          show_id: bookId ?? '',
        })
    }

    const sendTooltipAnalyticsDataHandler = (title) => {
      let module_name = ''
      if (title === 'Chapter Listeners') { module_name = 'newchapterlisteners_infoicon' }
      else if (title === 'Active Listeners') { module_name = 'activelisteners_infoicon' }
      else if (title === 'Word Counts') { module_name = 'wordcounts_infoicon' }
      else if (title === 'Published Days') { module_name = 'publisheddays_infoicon' }
      else if(title==='Revenue Share'){module_name='revenueshare_infoicon'}
      else if(title==='Revenue'){module_name='revenue_infoicon'}
      else if(title==='Revenue Fast Pass'){module_name='revenuefastpass_infoicon'}
      else if(title==='Schedule Episodes'){module_name='scheduleepisodes_infoicon'}
      handleEventLog('home_seriesperformance', 'button_click', {
        show_id: bookId ?? '',
        module_name,
      })
    }

    useEffect(() => {
      if('IntersectionObserver' in window){
        const observer = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting)
                handleEventLog('home_seriesperformance', 'button_view', {
                  show_id: bookId ?? '',
                  module_name: 'clickhereformoreinformation',
                })
            },
            {
              root: null,
              rootMargin: '0px',
              threshold: 1,
            }
        )
        if (viewMoreInfoButton.current) observer.observe(viewMoreInfoButton.current)
        return () => observer.disconnect()
      }
    }, [viewMoreInfoButton.current])

    useEffect(() => {
      if('IntersectionObserver' in window){
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {   
                      if (entry.isIntersecting) {
                          handleEventLog('home_novelperformance', 'button_view', {
                              show_id: bookId ?? '',
                              module_name: 'hero test',
                          })
                      }
                  })
          }
        )
        
        tooltipInfoButton.current?.forEach(btn => {
            if(btn) observer.observe(btn)
        }) 
        return () => observer.disconnect()
      }
    }, [tooltipInfoButton.current.length])

    const infoIconReferenceCallback = useCallback((element) => {
      if(element) tooltipInfoButton.current.push(element)
    },[])

    const handleDataHeading = (title) => {
      if (title === 'Chapter Listeners')
        return 'New Chp Listeners'
      if (title === 'Active Listeners')
        return 'Active Listeners %'
      return title
    }

    return(
        <>
            { seriesPerformanceData && Object.keys(seriesPerformanceData).length !== 0 && 
                <Box backgroundColor="surface.foreground" p={!newVersion && '16px'} mb={newVersion && '8px'}>
                    <Box variant="flex">
                        <PerformanceHeading>Series Performance</PerformanceHeading>
                        <DropDownSelect
                            name="book"
                            placeholder="Name of the novel"
                            selectOptions={[
                                {id: 'last_7_days', title: 'last 7 days'},
                                {id: 'this_week', title: 'This Week (Mon - Sun)'},
                                {id: 'this_month', title: 'This Month'},
                                {id: 'last_30_days', title: 'last 30 days'},
                                {id: 'all_time', title: 'All Time'}

                            ]}
                            idKey="id"
                            nameKey="title"
                            value={filter}
                            clickOnSelect
                            noBorderAndPadding
                            customWidth="30vw"
                            onChange={title => setFilter(title)}
                        />
                    </Box>
                    {lastRefreshTime && 
                      <RefreshTime>
                        Last Refresh at {handleRefreshTime(lastRefreshTime)}
                      </RefreshTime>}
                    <PerformanceMainDiv newVersion={newVersion}>
                        {seriesPerformanceData?.map((data) => 
                            <PerformanceDiv newVersion={newVersion}>
                                <ColumnFlexContainer>
                                    <Box variant="flex">
                                      <DataHeading>
                                        {data?.title && handleDataHeading(data.title)}
                                      </DataHeading>
                                      <Tooltip content={toolTipContent[data.title]} direction="bottom">
                                        <InfoIcon ref={infoIconReferenceCallback} onClick={() => sendTooltipAnalyticsDataHandler(data.title)} />
                                      </Tooltip> 
                                    </Box>
                                    <DataCount>{Math.round(data[filter]?.count * 100) / 100}{data.title.includes('Readers') && ' %'}</DataCount>
                                    {filter !== 'all_time' && <RowFlexContainerWithGap>
                                        {(data[filter]?.percentage < 0) ? <RedArrowDown /> :  (data[filter]?.percentage !== 0 && <GreenArrowUp />)}
                                        <DataPercentage isNegative={data[filter]?.percentage < 0}>{(Math.round(data[filter]?.percentage * 100) / 100).toString().split('-').join('')}%</DataPercentage>
                                    </RowFlexContainerWithGap>}
                                    {filter !== 'all_time' && <ComparisonText>Compared to previous period</ComparisonText>}
                                </ColumnFlexContainer>
                            </PerformanceDiv>
                        )}
                    </PerformanceMainDiv>
                </Box>
            }
            {seriesPerformanceData && Object.keys(seriesPerformanceData).length !== 0 && newVersion && <ViewMore ref={viewMoreInfoButton} href={`/analytics?bookId=${bookId}`} onClick={sendAnalyticsDataHandler}>Click here for more information</ViewMore>}
        </>
    )
}

export default SeriesPerformanceCard